import { Skeleton } from './Skeleton';
export default Skeleton;
//export * from './SkeletonStyleProps';
export * from './SkeletonTheme';
